import { Row, Col, Image } from "react-bootstrap";
import Layout from "../../Components/Website/Layout";
import Header from "../../Components/common/Header";
import Footer from "../../Components/common/Footer";
import mahmoudImg from "../../Imge/about_2.png";
import "./Aboutus.css";

export default function Aboutus() {
  return (
    <>
      <Header />
      <div className="Aboutus bg-light py-5">
        <Layout>
          <div className="py-5">
            <Row className="align-items-center">
              <Col md={5} className="mb-4 mb-md-0 animate-image">
                <Image
                  src={mahmoudImg}
                  alt="الأستاذ محمود عبد اللطيف"
                  fluid
                  rounded
                />
              </Col>
              <Col md={7} className="animate-text">
                <h2 className="mb-3">
                  <span className="gold">الأستاذ محمود عبد اللطيف الصبروط</span>
                </h2>
                <p>
                  خريج كلية اللغة العربية بجامعة الأزهر العريقة، وحاصل على الدبلوم التربوي والدراسات العليا بجامعة الأزهر. يعمل في مجال تدريس اللغة العربية منذ عام <span className="gold">2016</span>.
                </p>
                <p>
                  متخصص في شرح اللغة العربية بكافة فروعها (النحو، الصرف، البلاغة، الأدب، النصوص، والقراءة) لطلاب الثانوية العامة والأزهرية بأسلوب حديث ومبتكر يجمع بين التبسيط والعمق الأكاديمي.
                </p>
                <p>
                  مؤسس <span className="gold">"قناة نوح التعليمية"</span> وصاحب الفكرة الرائدة <span className="gold">«نُوحٌ نَحوَ نَحوٍ جَدِيدٍ»</span> التي تهدف إلى تقديم لغة الضاد بصورة عصرية مرنة تجعل الطالب أكثر فهمًا وثقة وتميزًا.
                </p>
                <p>
                  مبتكر منهجية <span className="gold">«الهندسة النحوية»</span> الفريدة التي تعتمد على معادلات نحوية مبتكرة تثبت المعلومة في ذهن الطالب بطريقة سهلة وسريعة للغاية، بعيداً عن تعقيدات الحفظ والتلقين التقليدي.
                </p>
                <p>
                  يؤمن الأستاذ محمود بأن التعليم الحقيقي يبدأ من الفهم العميق والتحليل، لذلك يحرص دائماً على تبسيط أصعب القواعد بأسلوب سلس واحترافي، وتدريب الطلاب على الاستنباط والتحليل. وقد ساعد خلال مسيرته آلاف الطلاب على تطوير مستواهم الدراسي وتحقيق نتائج مبهرة بفضل الله وتوفيقه.
                </p>
              </Col>
            </Row>
          </div>
        </Layout>
      </div>
      <Footer />
    </>
  );
}
